<template>
  <div id="app">

    <nav class="navbar">
      <div class="container">
        <div class="flex">
          <div class="logo">
            <img src="@/assets/ic_launcher_round.png" alt="1900软件工厂" />
            <span>1900软件工厂</span>
          </div>
          <div class="nav-menu" :class="{ active: isMenuOpen }">
             <a href="#1900" @click="closeMenu">1900节拍器</a>
           
            <a href="#mini-products" @click="closeMenu">八爪鱼Mini</a>
             <a href="#inkfish" @click="closeMenu">八爪鱼客户端</a>
            <!-- <a href="#how-it-works" @click="closeMenu">工作原理</a>
            <a href="#features" @click="closeMenu">功能特色</a>
            <a href="#download" @click="closeMenu">立即下载</a>
            <a href="#faq" @click="closeMenu">常见问题</a> -->
			<!-- <a href="#support" @click="closeMenu">使用帮助</a> -->
          </div>
          <div class="hamburger" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </nav>
 
    <!-- <div class="vbg">
      <video class="blurred-background" autoplay muted loop>
        <source src="@/assets/bg.mp4" type="video/mp4" />
      </video>

      <div class="hero">
        <div class="container">
          <h1 class="hero-title">八爪鱼桌面端</h1>
          <p class="subtitle">专业下载网络媒体工具 - 支持微信小程序、浏览器及各类客户端</p>
          <button class="cta-button primary" @click="downfile">立即下载</button>
          <p class="supported-platforms">支持 Windows 7 及以上系统</p>
        </div>
      </div>
    </div> -->
    <main> 
       <section id="1900" class="mini-products-section">
        <div class="container">
          <h2 class="section-title">1900节拍器</h2>
          <div class="section-subtitle">简约而不简单，专业节拍器</div>
          <div class="section-subtitle warning">1900节拍器 为你发声</div>
          <div class="mini-products-grid">
            
            <div class="mini-product-card">
              <div class="product-icon">
                <img src="@/assets/ic_launcher_round.png" alt="1900节拍器" />
              </div>
              <h3>1900节拍器 for Android</h3>
              <p>电子节拍器，精准节拍 丰富音效 节拍自选 人声喊拍等</p>
              <div class="product-features">
                <span class="feature-tag Android">精准节拍</span>
                <span class="feature-tag Android">丰富音效</span>
                <span class="feature-tag Android">人声喊拍</span>
              </div>
              <button class="mini-download-btn Android" @click="downloadMetronome">立即下载</button>
            </div>
          </div>
        </div>
      </section>
      <section id="mini-products" class="mini-products-section">
        <div class="container">
          <h2 class="section-title">八爪鱼Mini</h2>
          <div class="section-subtitle">轻量级版本，专为不同平台优化，随时随地享受八爪鱼的强大功能</div>
          <div class="section-subtitle warning">不支持微信小程序等其他客户端软件的数据获取</div>
    
          <div class="mini-products-grid">
           

            <div class="mini-product-card">
              <div class="product-icon">
                <img src="@/assets/android-logo.svg" alt="Android" />
              </div>
              <h3>八爪鱼Mini for Android</h3>
              <p>Android兼容主流安卓设备</p>
              <div class="product-features">
                <span class="feature-tag Android">视频预览</span>
                <span class="feature-tag Android">图片预览</span>
              
              </div>
              <button class="mini-download-btn Android" @click="downloadAndroid">立即下载</button>
            </div>

           

            <!-- <div class="mini-product-card">
              <div class="product-icon">
                <img src="@/assets/windows-logo.svg" alt="Windows" />
              </div>
              <h3>八爪鱼Mini for Windows</h3>
              <p>轻量级Windows版本，占用资源更少，运行更流畅</p>
              <div class="product-features ">
                <span class="feature-tag windows">轻量快速</span>
               
                <span class="feature-tag windows">操作简单</span>
              </div>
              <button class="mini-download-btn windows" @click="downloadWindows">立即下载</button>
            </div> -->
          </div>
        </div>
      </section>
 <section class="mini-products-section" id="inkfish">
        <div class="container">
          <h2 class="section-title">八爪鱼客户端</h2>
          <div class="section-subtitle">八爪鱼客户端 专业媒体资源下载工具</div>
          </div>
          </section>
      <div class="vbg">
      <video class="blurred-background" autoplay muted loop>
        <source src="@/assets/bg.mp4" type="video/mp4" />
      </video>

      <div class="hero">
        <div class="container">
          <h1 class="hero-title">八爪鱼桌面端</h1>
          <p class="subtitle">专业下载网络媒体工具 - 支持微信小程序、浏览器及各类客户端</p>
          <button class="cta-button primary" @click="downfile">立即下载</button>
          <p class="supported-platforms">支持 Windows 7 及以上系统</p>
        </div>
      </div>
    </div>


      <section id="features" class="features-section">
        <div class="container">
          <h2 class="section-title">功能特色</h2>
          <div class="features-grid">
            <div class="feature-card">
              <div class="feature-content">
                <h3 id="resource-download">多种资源下载</h3>
                <ul>
                  <li>微信小程序资源获取</li>
                  <li>抖音、B站等短视频下载</li>
                  <li>各类图片资源收集</li>
                  <li>文档及其他格式文件</li>
                </ul>
                <div id="wechat-miniprogram"></div>
                <div id="douyin"></div>
                <div id="kuaishou"></div>
                <div id="weibo-zhihu"></div>
              </div>
            </div>
            <video autoplay muted loop class="vbg2">
              <source src="@/assets/bg2.mp4" type="video/mp4" />
            </video>
          </div>
          
          <div class="features-grid reverse">
            <div class="feature-card">
              <div class="feature-content">
                <h3 id="security">安全可靠</h3>
                <ul>
                  <li>采用本地代理技术，数据不外泄</li>
                  <li>无需上传任何个人隐私信息</li>
                  <li>绿色无毒，通过多重安全检测</li>
                  <li>完全离线操作，保护用户隐私</li>
                </ul>
                <div id="high-quality-download"></div>
                <div id="batch-download"></div>
              </div>
            </div>
            <img src="@/assets/bg4.png" alt="安全演示" class="vbg2" />
          </div>
        </div>
      </section>

      <section id="how-it-works" class="how-it-works-section">
        <div class="container">
          <h2 class="section-title">工作原理</h2>
          <div class="steps">
            <div class="step">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" width="60" height="60" fill="none" stroke="#ff0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2Z"/>
                  <path d="M10 8H14V22H10V8Z"/>
                </svg>
              </div>
              <h3>启动代理</h3>
              <p>运行八爪鱼，自动设置本地代理服务器</p>
            </div>
            <div class="step">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" width="60" height="60" fill="none" stroke="#00aa00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"/>
                  <path d="M12 8V12L15 15"/>
                </svg>
              </div>
              <h3>浏览内容</h3>
              <p>正常使用微信小程序、浏览器或其他客户端应用</p>
            </div>
            <div class="step">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" width="60" height="60" fill="none" stroke="#00aaff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 21L16.65 16.65"/>
                  <circle cx="11" cy="11" r="8"/>
                  <path d="M21 12H18"/>
                  <path d="M12 3V6"/>
                  <path d="M3 12H6"/>
                  <path d="M12 18V21"/>
                </svg>
              </div>
              <h3>智能识别</h3>
              <p>自动捕获网络请求中的图片、视频等媒体资源</p>
            </div>
            <div class="step">
              <div class="step-icon">
                <svg viewBox="0 0 24 24" width="60" height="60" fill="none" stroke="#ffaa00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2Z"/>
                  <path d="M20 14V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14"/>
                  <path d="M12 12L16 16"/>
                  <path d="M12 12L8 16"/>
                  <path d="M12 12V18"/>
                </svg>
              </div>
              <h3>一键下载</h3>
              <p>在助手界面中选择所需资源，点击即可下载</p>
            </div>
          </div>
        </div>
      </section>

      <section id="download" class="download-section">
		 
        <div class="container">
          <h2 class="section-title white">立即体验</h2>
          <p class="download-description">免费下载八爪鱼，解锁无限可能</p>
          <div class="download-options">
            <div class="download-card">
              <img src="@/assets/windows-logo.svg" alt="Windows" />
              <h3>Windows 版</h3>
              <p>支持 Windows 7 及以上系统</p>
              <button class="download-btn" @click="downfile">下载 (.msi)</button>
            </div>

            <div class="download-card">
              <div class="coming-soon-badge">即将推出</div>
              <img src="@/assets/icon-dict.svg" alt="Mac" />
              <h3>macOS 版</h3>
              <p>支持 macOS 10.12 及以上版本</p>
              <button class="download-btn disabled" disabled>敬请期待</button>
            </div>
          </div>
        </div>
      </section>

      <section id="faq" class="faq-section">
		
        <div class="container">
			 
          <h2 class="section-title">常见问题</h2>
		   
          <div class="faq-container">
            <div class="faq-item">
              <div class="faq-question">
                <h3>“八爪鱼”是否安全？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>非常安全。“八爪鱼”采用本地代理技术，所有数据都在本地处理，不会上传到任何服务器。软件已通过多家安全软件检测，无病毒、无木马。</p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-question">
                <h3>“八爪鱼”是否收费？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>目前是完全免费的软件，不收取任何费用。</p>
              </div>
            </div>
			<div class="faq-item">
			  <div class="faq-question">
			    <h3>“八爪鱼”如何添加功能？</h3>
			    <span class="faq-toggle">+</span>
			  </div>
			  <div class="faq-answer">
			    <p>欢迎您来定制我们的产品，在不考虑大改的情况下，我们这里需要收取一定的开发费用，敬请谅解！</p>
			  </div>
			</div>
            <div class="faq-item">
              <div class="faq-question">
                <h3>支持哪些平台的资源下载？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>支持微信小程序、抖音、B站、微博、知乎等几乎所有主流平台的图片和视频资源下载。只要是通过网络传输的媒体资源，都可以被识别和下载。</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question">
                <h3>是否有使用次数等限制？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>没有限制。VIP用户终身免费更新、在线一对一服务，无后顾之忧。</p>
              </div>
            </div>
            
            <div class="faq-item">
              <div class="faq-question">
                <h3>下载的文件保存在哪里？</h3>
                <span class="faq-toggle">+</span>
              </div>
              <div class="faq-answer">
                <p>默认保存在"我的文档/"文件夹中。您可以在软件设置中自定义保存路径。</p>
              </div>
            </div>
          </div>
          <div class="text-center" style="margin-top: 30px;">
            <button id="load-more-faq" class="cta-button primary">展开更多问题</button>
          </div>
        </div>
      </section>
    </main>

    <footer id="support" class="footer" >
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h4>产品特色</h4>
            <a href="#resource-download">多种资源支持</a>
            <a href="#security">本地代理技术</a>
            <a href="#high-quality-download">高清无损下载</a>
            <a href="#batch-download">批量下载功能</a>
          </div>
          
          <div class="footer-section">
            <h4>支持平台</h4>
            <a href="#wechat-miniprogram">微信小程序</a>
            <a href="#douyin">抖音短视频</a>
            <a href="#kuaishou">B站短视频</a>
            <a href="#weibo-zhihu">微博/知乎等</a>
          </div>
		  <div class="footer-section secondary"  >
		    <h4>使用指南</h4>
		    <a href="https://v.douyin.com/gbQCUj8gMY8/">🌟视频教学</a>
		    <a href="https://gitcode.com/SUI517/xtRqHelper/blob/master/readme/license.md">📚软件使用协议</a>
		    <a href="https://gitcode.com/SUI517/xtRqHelper/blob/master/readme/guide.md">🚀售后服务指南</a>
		   
		  </div>
        </div>

         
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isMenuOpen: false
    };
  },
  mounted() {
    // 初始化 Intersection Observer
    this.initObservers();
    
    // FAQ 点击事件
    this.initFAQ();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    initObservers() {
      const cardObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("show");

              // 列表项动画
              const items = entry.target.querySelectorAll(".feature-content li");
              items.forEach((item, i) => {
                item.style.setProperty("--i", i);
                setTimeout(() => {
                  item.classList.add("show");
                }, i * 300);
              });

              cardObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: "0px 0px -50px 0px",
        }
      );

      document.querySelectorAll(".feature-card").forEach((card) => {
        cardObserver.observe(card);
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("show");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: "0px 0px 0px 0px",
        }
      );

      document.querySelectorAll(".feature-card, .step, .download-card, .mini-product-card").forEach((card, i) => {
        card.style.setProperty("--i", i);
        observer.observe(card);
      });
    },
    
    initFAQ() {
      const faqQuestions = document.querySelectorAll('.faq-question');
      faqQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const faqItem = question.parentElement;
          faqItem.classList.toggle('active');
          
          const toggle = question.querySelector('.faq-toggle');
          toggle.textContent = faqItem.classList.contains('active') ? '-' : '+';
        });
      });
      
      // 展开更多问题按钮
      const loadMoreBtn = document.getElementById('load-more-faq');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', () => {
          // 这里可以添加加载更多FAQ的逻辑
          // 目前我们只是隐藏按钮并显示提示信息
          loadMoreBtn.style.display = 'none';
          
          // 创建提示信息
          const info = document.createElement('p');
          info.textContent = '没有更多问题了';
          info.style.textAlign = 'center';
          info.style.color = '#6c757d';
          info.style.marginTop = '20px';
          
          loadMoreBtn.parentElement.appendChild(info);
        });
      }
    },
    
    downfile() {
      const url = "./exe/inkfish.msi";
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadMac() {
      // 模拟macOS下载
      alert("八爪鱼Mini for macOS 正在准备下载...");
      // 实际项目中这里应该是真实的下载链接
      // const url = "./exe/OctopusMini-macOS.dmg";
      // this.createDownloadLink(url);
    },
    downloadIOS() {
      // 跳转到App Store
      alert("即将跳转到App Store...");
      // 实际项目中这里应该是App Store链接
      // window.open("https://apps.apple.com/app/octopus-mini/idxxxxxx", "_blank");
    },
    downloadAndroid() {
    
      const url = "./apk/inkfishmini.apk";
      this.createDownloadLink(url);
    },
    downloadMetronome() {
      // 1900节拍器Android版本下载
 
      const url = "./apk/metronome.apk";
      this.createDownloadLink(url);
    },
    downloadWindows() {
      // 模拟Windows Mini版本下载
      alert("八爪鱼Mini for Windows 正在准备下载...");
      // 实际项目中这里应该是真实的下载链接
      // const url = "./exe/OctopusMini-Windows.exe";
      // this.createDownloadLink(url);
    },
    createDownloadLink(url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleScroll() {},
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    }
  },
};
</script>

<style scoped>
 
body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
  line-height: 1.6;
  color: #212529;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  background-color: #f8f9fa;
  scroll-behavior: smooth;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 导航栏 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 15px 0;
  position: sticky;
  top: 0;
  z-index: 100;
  transition:all 0.3s ease;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  font-size: 1.4rem;
  color: #01030f;
  animation: fadeInDown 0.8s ease;
}

.logo img {
  height: 48px;
  width: 48px;
  object-fit: contain;
  animation: pulse 2s infinite;
}

.nav-menu {
  display: flex;
  gap: 35px;
  animation: fadeInDown 0.8s ease;
}

.nav-menu a {
  text-decoration: none;
  color: #212529;
  font-weight: 500;
  font-size: 1.05rem;
  transition: all 0.3s ease;
  position: relative;
  padding: 5px 0;
}

.nav-menu a:after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: #4361ee;
  transition:all 0.3s ease;
}

.nav-menu a:hover:after {
  width: 100%;
}

.nav-menu a:hover {
  color: #4361ee;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  z-index: 101;
}

.hamburger span {
  width: 28px;
  height: 3px;
  background-color: #212529;
  margin: 4px 0;
  transition: 0.3s;
  border-radius: 2px;
}

/* 英雄区域 */
.vbg {
		
  height: 600px;
  width: 100%;
  padding: 75px 0;
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.blurred-background {

  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.3;
  top: 0;
  left: 0;
  object-fit: cover;
  z-index: 1;
}

.hero {
 
  color: white;
  text-align: center;
  z-index: 3;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  animation: fadeIn 1s ease;
}

.hero-title {
  font-size: 3rem;
  margin-bottom: 20px;
  font-weight: 800;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 1s ease;
}

.subtitle {
  font-size: 1.3rem;
  margin-bottom: 35px;
  max-width: 700px;
  font-weight: 400;
  opacity: 0.9;
  animation: fadeInUp 1s ease 0.2s both;
}

.cta-button {
  background: linear-gradient(90deg, #4361ee, #3f37c9);
  color: white;
  border: none;
  margin: 25px 0;
  padding: 15px 45px;
  border-radius: 50px;
  font-size: 1.2rem;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(67, 97, 238, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
  letter-spacing: 0.5px;
  animation: fadeInUp 1s ease 0.4s both;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(67, 97, 238, 0.4);
  background: linear-gradient(90deg, #3f37c9, #4361ee);
}
.cta-button.primary {
 
  transform: translateY(-3px);
  box-shadow: 0 8px 5px rgba(67, 97, 238, 0.4);
  background: rgba(255, 255, 255, 1);
 
  border: 2px solid rgba(255, 255, 255, 0.4);
  color: rgba(67, 97, 238, 1);
}
 

.cta-button.secondary {
  background: transparent;
  border: 2px solid #4361ee;
  color: #4361ee;
}

.cta-button.secondary:hover {
  background: linear-gradient(90deg, #4361ee,#3f37c9);
  color: white;
  border-color: transparent;
}

.supported-platforms {
  font-size: 1rem;
  opacity: 0.8;
  font-weight: 400;
  animation: fadeInUp 1s ease 0.6s both;
}

/* 功能区域 */
.features-section {
  margin: 100px 0;
  padding: 20px 0;
  position: relative;
  z-index: 2;
  scroll-margin-top: 80px; /* 用于现代浏览器的锚点偏移 */
}

/* 为不支持scroll-margin-top的旧浏览器提供兼容方案 */
@supports not (scroll-margin-top: 80px) {
  .features-section:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}

/* 其他锚点目标也需要同样的处理 */
#resource-download,
#security {
  scroll-margin-top: 80px;
}

.step-icon {
  width: 80px;
  height: 80px;
 
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  box-shadow: 0 4px 10px rgba(67, 97, 238, 0.3);
  padding: 10px;
}

.step-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@supports not (scroll-margin-top: 80px) {
  #resource-download:before,
  #security:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}

/* 为锚点目标添加偏移量，避免被固定导航栏遮挡 */
.features-section:before {
  content: "";
  display: block;
  height: 80px; /* 导航栏高度 */
  margin-top: -80px;
  visibility: hidden;
  pointer-events: none;
}

/* 为八爪鱼Mini产品系列添加锚点偏移 */
.mini-products-section {
  scroll-margin-top: 80px;
}

@supports not (scroll-margin-top: 80px) {
  .mini-products-section:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
  font-size: 2.5rem;
  font-weight: 700;
  color: #212529;
  position: relative;
  animation: fadeInUp 0.8s ease;
}

.section-title:after {
  content: '';
  position: absolute;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #4361ee,#f72585);
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
}

.features-grid {
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 12px;
  flex-wrap: wrap;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-delay: calc(0.15s * var(--i));
  justify-content: center;
  background: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 50px;
  /* 移除 overflow: hidden 避免内容被裁剪 */
  opacity: 1; /* 默认显示 */
  animation: fadeInUp 0.8s ease forwards;
  position: relative;
  z-index: 1;
}

.features-grid.reverse {
  flex-direction: row-reverse;
}

.feature-content {
  display: flex;
  padding: 50px;
  flex-direction: column;
  flex: 1;
  min-width: 300px;
}

.feature-card {
  opacity: 0; /* 初始状态隐藏，用于动画效果 */
  flex: 1;
  transform: translateY(40px);
  transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition-delay: calc(0.15s * var(--i));
}

.feature-card.show {
  opacity: 1;
  transform: translateY(0) scale(1.02);
  transition: all 0.3s ease;
}

.vbg2 {
  flex: 1;
  justify-content: center;
  min-width: 300px;
  height: 350px;
  object-fit: cover;
}

.feature-content h3 {
  margin-bottom: 25px;
  color: #4361ee;
  font-size: 1.8rem;
  font-weight: 700;
}

.feature-content ul {
  list-style: inside;
  padding: 0;
}

.feature-content li {
  opacity: 0; /* 初始状态隐藏，用于动画效果 */
  transform: translateY(20px);
  transition: all 0.5s ease;
  transition-delay: calc(0.1s * var(--i));
  font-size: 1.1rem;
  font-weight: 500;
  margin-bottom: 15px;
  padding-left: 30px;
  position: relative;
  color: #6c757d;
}

.feature-content li.show {
  opacity: 1;
  transform: translateY(0);
}

/* 八爪鱼Mini产品系列 */
.mini-products-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  text-align: center;
}

.mini-products-section .section-title:after {
  background: linear-gradient(90deg, #4361ee, #4cc9f0);
}

.section-subtitle {
  font-size: 1.2rem;
  color: #6c757d;

  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.section-subtitle.warning {
  color: #eac233;
  font-size: 1.3rem;
    margin-bottom: 60px;
  font-weight: 800;
}

.mini-products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  max-width: 1200px;
 
  margin: 0 auto;
}

.mini-product-card {
 
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(30px);
}

.mini-product-card.show {
  opacity: 1;
  transform: translateY(0);
  transition-delay: calc(0.1s * var(--i));
}

.mini-product-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.mini-product-card:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #4361ee, #4cc9f0);
}

.product-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 50%;
  padding: 15px;
}

.product-icon img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.mini-product-card h3 {
  font-size: 1.4rem;
  margin-bottom: 15px;
  color: #212529;
  font-weight: 600;
}

.mini-product-card p {
  color: #6c757d;
  margin-bottom: 25px;
  line-height: 1.6;
  font-size: 1rem;
}

.product-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-bottom: 30px;
}

.feature-tag {
  background: linear-gradient(135deg, #4361ee, #4895ef);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.mini-download-btn {
  
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(67, 97, 238, 0.3);
}
 
.mini-download-btn.windows,.windows{
background: linear-gradient(135deg, #efe150, #FFA500);
}
.mini-download-btn.Android,.Android{
background: linear-gradient(135deg, #16fb0a, #04870c);
}
.mini-download-btn.iPhone,.iPhone{
background: linear-gradient(135deg, #e05158, #e40830);
}
.mini-download-btn.macOS,.macOS{
background: linear-gradient(135deg, #1831ef, #4895ef);
}

.mini-download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(67, 97, 238, 0.4);
}

/* 工作原理 */
.how-it-works-section {
  background-color: #ffffff;
  padding: 100px 0;
  text-align: center;
}

.how-it-works-section .section-title:after {
  background: linear-gradient(90deg, #f72585, #4cc9f0);
}

.steps {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
}

.step {
  flex: 1;
  min-width: 220px;
  background: #ffffff;
  padding: 40px 30px;
  border-radius:12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition:all 0.3s ease;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateY(30px);
}

.step.show {
  opacity: 1;
  transform: translateY(0);
  transition-delay: calc(0.1s * var(--i));
}

.step:hover {
  transform: translateY(-10px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.step:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #4361ee,#f72585);
}

.step h3 {
  margin-bottom: 20px;
  color:#212529;
  font-size: 1.4rem;
  font-weight: 600;
}

.step p {
  color: #6c757d;
  font-size: 1.05rem;
  line-height: 1.7;
}

/* 下载区域 */
.download-section {
  background: linear-gradient(135deg, #4361ee, #3a0ca3);
  padding: 100px 0;
  text-align: center;
  color: white;
}

.download-section .section-title:after {
  background: linear-gradient(90deg, #4cc9f0, #4895ef);
}

.download-section h2 {
  font-size: 2.5rem;
  margin-bottom: 25px;
  font-weight: 700;
}

.download-description {
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto 50px;
  font-weight: 300;
  opacity: 0.9;
}

.download-options {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 50px;
  flex-wrap: wrap;
}

.download-card {

  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  min-width: 280px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.18);
  opacity: 0;
  transform: translateY(30px);
}

.download-card.show {
  opacity: 1;
  transform: translateY(0);
  transition-delay: calc(0.1s * var(--i));
}

.download-card:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}

.download-card img {
  height: 70px;
  margin-bottom: 20px;
}

/* 修改SVG图标颜色为白色 */
.download-card img[src$=".svg"] {
  filter: brightness(0) invert(1);
}

.download-card h3 {
  margin-bottom: 15px;
  font-size: 1.5rem;
  font-weight: 600;
}

.download-card p {
  margin-bottom: 25px;
  font-size: 1rem;
  opacity: 0.8;
}

.download-btn {
  background: white;
  color: #4361ee;
  border: none;
  color:#3a0ca3;
  padding: 12px 35px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 1.05rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.download-btn:hover:not(.disabled) {
  background: linear-gradient(90deg, #f72585, #b5179e);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.download-btn.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.coming-soon-badge {
  position: absolute;
  top: -12px;
  right: -12px;
  background: linear-gradient(90deg,  #ffaa00, #ff0000);
  color: white;
  padding: 8px 15px;
  border-radius: 30px;
  font-size: 0.85rem;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(247, 37, 133, 0.3);
}
 
/* FAQ 部分 */
.faq-section {
  padding: 100px 0;
  background-color: #f8f9fa;
}
.white{
	color: #fff;
}
.faq-section .section-title:after {
  background: linear-gradient(90deg, #0370ff, #4895ef);
}

.faq-container {
  max-width: 900px;
  margin: 0 auto;
}

.faq-item {
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition:all 0.3s ease;
}

.faq-item:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.faq-question {
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.faq-question:hover {
  background-color: #f8f9fa;
}

.faq-question h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: #212529;
}

.faq-toggle {
  font-size: 1.8rem;
  font-weight: 300;
  color: #4361ee;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.faq-answer {
  padding: 0 30px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease, padding 0.4s ease, background 0.3s ease;
  background: #f8f9fa;
}

.faq-item.active .faq-answer {
  padding: 25px 30px;
  max-height: 500px;
}

.faq-answer p {
  color: #6c757d;
  line-height: 1.7;
  font-size: 1.05rem;
}

/* 页脚 */
.footer {
  background: #0f172a;
  color: #cbd5e1;
  padding: 70px 0 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  margin-bottom: 50px;
  gap: 40px;
}

.footer-section h4 {
  margin-bottom: 25px;
  font-size: 1.3rem;
  color: white;
  font-weight: 600;
  position: relative;
  padding-bottom: 10px;
}
.footer-section.secondary h4{
	color: #55aaff;	 
}
.footer-section.secondary a{
	color: #ebeb00;	 
}
.footer-section h4:after{
  content: '';
  position: absolute;
  width: 40px;
  height: 3px;
  background: #4361ee;
  bottom: 0;
  left: 0;
  border-radius: 2px;
}

.footer-section a {
  color: #94a3b8;
  margin-bottom: 12px;
  text-decoration: none;
  transition: all 0.3s ease;
  display: block;
  font-size: 1.05rem;
  line-height: 1.6;
}

.footer-section a:hover {
  color: #4361ee;
  transform: translateX(5px);
}

.copyright {
  text-align: center;
  color: #94a3b8;
  font-size: 1rem;
  padding-top: 30px;
  border-top: 1px solid #1e293b;
  margin-top: 20px;
}

.copyright a {
  text-decoration: none;
  transition: all 0.3s ease;
  color: #94a3b8;
}

.copyright a:hover {
  color: #4361ee;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* 响应式设计 */
@media screen and (max-width: 1200px) {
  .container {
    padding: 0 25px;
  }
  
  .hero-title {
    font-size: 2.8rem;
  }
  
  .subtitle {
    font-size: 1.2rem;
  }
  
  .features-grid {
    flex-direction: column;
  }
  
  .features-grid.reverse {
    flex-direction: column;
  }
  
  .vbg2 {
    width: 100%;
    height: 350px;
  }
  
  .steps {
    flex-direction: column;
  }
  
  .download-options {
    flex-direction: column;
    align-items: center;
  }
  
  .feature-content {
    padding: 40px;
  }
}

@media screen and (max-width: 992px) {
  .container {
    padding: 0 20px;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .subtitle {
    font-size: 1.1rem;
  }
  
  .vbg2 {
    height: 300px;
  }
  
  .step {
    min-width: 200px;
  }
  
  .feature-content {
    padding: 35px;
  }
}
  .logo span {
	  color: #020c1a;
  }
@media screen and (max-width: 768px) {
  .navbar {
    padding:  15px; 
  }
  
  .logo {
    font-size: 1.3rem;
  }

  .logo img {
    height: 32px;
  }
  
  .nav-menu {
    position: fixed;
    left: -100%;
    top: 0;
    flex-direction: column;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    width: 100%;
    height: 100vh;
    text-align: center;
    transition: 0.4s;
    box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
    padding: 100px 0;
    z-index: 100;
  }
  
  .nav-menu.active {
    left: 0;
	 box-shadow: 0 10px 27px rgba(0, 0, 0, 0.05);
	 background-color: rgba(255, 255, 255, 0.99);
  }
  
  .nav-menu a {
    padding: 20px;
    display: block;
    font-size: 1.2rem;
  }
  
  .hamburger {
    display: flex;
  }
  
  .hamburger.active span:nth-child(2) {
    opacity: 0;
  }
  
  .hamburger.active span:nth-child(1) {
    transform: translateY(11px) rotate(45deg);
  }
  
  .hamburger.active span:nth-child(3) {
    transform: translateY(-11px) rotate(-45deg);
  }
  
  .vbg {
    height: 500px;
  }
  
  .hero-title {
    font-size: 2.2rem;
  }
  
  .subtitle {
    font-size: 1.05rem;
  }
  
  .feature-content {
    padding: 30px;
  }
  
  .step {
    padding: 30px 20px;
  }
  
  .download-card {
    padding: 30px 20px;
    min-width: 250px;
  }
  
  .faq-question {
    padding: 20px;
  }
  
  .faq-item.active .faq-answer {
    padding: 20px;
  }
  
  .section-title {
    font-size: 2.2rem;
  }
  
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

@media screen and (max-width: 576px) {
  .container {
    padding: 0 15px;
  }
  
  .hero-title {
    font-size: 2rem;
  }
  
  .vbg {
    height: 450px;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .feature-content {
    padding: 25px 20px;
  }
  
  .step {
    padding: 25px 15px;
    min-width: 100%;
  }
  
  .download-card {
    padding: 25px 15px;
    min-width: 100%;
  }
  
  .download-description {
    font-size: 1rem;
  }
  
  .faq-question {
    padding: 15px;
  }
  
  .faq-item.active .faq-answer {
    padding: 15px;
  }
  
  .nav-menu a {
    padding: 15px;
    font-size: 1.1rem;
  }
}

@media screen and (max-width: 480px) {
  .hero-title {
    font-size: 1.8rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .vbg {
    height: 400px;

 
  }
  
  .section-title {

    font-size: 1.8rem;
  }
  
  .feature-content {
    padding: 20px 15px;
  }
  
  .feature-content h3 {
    font-size: 1.5rem;
  }
  
  .feature-content li {
    font-size: 1rem;
    padding-left: 25px;
  }
  
  .step {
    padding: 20px 15px;
  }
  
  .step h3 {
    font-size: 1.2rem;
  }
  
  .step p {
    font-size: 0.95rem;
  }
  
  .download-card {
    padding: 20px 15px;
  }
  
  .download-card h3 {
    font-size: 1.3rem;
  }
  
  .download-description {
    font-size: 0.95rem;
  }
  
  .faq-question h3 {
    font-size: 1.1rem;
  }
  
  .faq-answer p {
    font-size: 0.95rem;
  }
}

/* 添加锚点偏移样式 */
.features-section {
  margin: 100px 0;
  padding: 20px 0;
  position: relative;
  z-index: 2;
  scroll-margin-top: 80px; /* 用于现代浏览器的锚点偏移 */
}

/* 为不支持scroll-margin-top的旧浏览器提供兼容方案 */
@supports not (scroll-margin-top: 80px) {
  .features-section:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}

/* 其他锚点目标也需要同样的处理 */
#resource-download,
#security,
#high-quality-download,
#batch-download,
#wechat-miniprogram,
#douyin,
#kuaishou,
#weibo-zhihu {
  scroll-margin-top: 80px;
}

@supports not (scroll-margin-top: 80px) {
  #resource-download:before,
  #security:before,
  #high-quality-download:before,
  #batch-download:before,
  #wechat-miniprogram:before,
  #douyin:before,
  #kuaishou:before,
  #weibo-zhihu:before {
    content: "";
    display: block;
    height: 80px;
    margin-top: -80px;
    visibility: hidden;
    pointer-events: none;
  }
}
</style>